// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"cc0f1f6c","453":"7164af2c","712":"18488883","736":"ad0e482f","881":"5e32ab2a","982":"ff8bb60d"}[chunkId] + ".chunk.js";
};